export const dummyOptions = [
    { label: 'Orange', value: 'orange', id: '22-x-cc-2' },
    { label: 'Banana', value: 'banana', id: '22-x-cc-3' },
    { label: 'Apple', value: 'apple', id: '22-x-cc-4' },
    { label: 'Orange2', value: 'orange2', id: '22-x-cc-22' },
    { label: 'Banana2', value: 'banana2', id: '22-x-cc-32' },
  ];
  